var vacanciesContainer = document.querySelector('.js-vacancies-container');
var vacancyButton = document.querySelector('.js-vacancy-search');
var vacancyLocation = document.querySelector('.js-vacancy-location');
var vacancyDepartment = document.querySelector('.js-vacancy-department');
var vacancies = document.querySelectorAll('.js-vacancies');

var dataSet = {};
var filteredVacancies = [];

if (vacancyLocation) {
	vacancyLocation.addEventListener('change', (e) => {
		dataSet['location'] = null;
		if (e.target.value.includes('Location') === false) {
			dataSet['location'] = e.target.value;
		}
	})
}

if (vacancyDepartment) {
	vacancyDepartment.addEventListener('change', (e) => {
		dataSet['department'] = null;
		if (e.target.value.includes('Department') === false) {
			dataSet['department'] = e.target.value;
		}
	})
}

if (vacancyButton) {
	vacancyButton.addEventListener('click', (e) => {
		var notFounds = document.querySelectorAll('.js-not-matches');
		if (notFounds) {
			for (let notFound of notFounds) {
				notFound.classList.add('hidden')
			}
		}

		for (let vacancy of vacancies) {
			vacancy.classList.remove('active')
			vacancy.classList.add('hidden')
		}

		let selectedFilterKeys = Object.keys(dataSet)
		let elements = Array.from(vacancies);

		let filteredVacancies = elements.filter((item) => selectedFilterKeys.every(key =>
			dataSet[key] === null || dataSet[key] === item.dataset[key]
		))

		if (filteredVacancies.length < 1) {
			if(vacanciesContainer) {
				vacanciesContainer.insertAdjacentHTML('beforeend','<p class="js-not-matches">No matches found</p>')
			}
		}

		for (let vacancy of filteredVacancies) {
			vacancy.classList.remove('hidden')
			vacancy.classList.add('active')
		}
	})
}

